import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add-plus",
  "use": "icon-add-plus-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 12\" id=\"icon-add-plus\">\r\n<rect y=\"5\" class=\"st0\" width=\"12\" height=\"2\" />\r\n<rect x=\"5\" class=\"st0\" width=\"2\" height=\"12\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol